/**
 * The aim of this context is to handle the Role Baased Control which are to be assigned by the team on the user.
 * e.g include menu accessibility, Page Access and Event actions which a user is able to do : Create,Read,Update Delete.  
 */
import { createContext } from "react";
const RoleBasedAccessControlContext = createContext({} as any);
export default RoleBasedAccessControlContext;